import './normalize.css';
import './banner.css';

/* Banner by Matthew Hanna | https://matthewhanna.com | MIT License */

function getThemeDialog(url, state) {
	const yes = state.test
		? url.pathname.includes('resume')
		: url === 'matthewhanna.net';
	const themePosition = yes ? '' : 'mh-banner-theme-right';
	const dialogPosition = yes ? 'dialog-left' : 'dialog-right';

	const themeListSize = state.themes.length;
	let opt = ' selected';
	const themeOptions = state.themes
		.map((m) => {
			const ret = `<option value='${m[0]}'${opt}>${m[1]}</option>`;
			opt = '';
			return ret;
		})
		.join(' ');

	return `
    <button class='mh-banner-theme ${themePosition}' aria-label='Theme toggle' title='Theme toggle'></button>
    <dialog class='mh-banner-theme-dialog ${dialogPosition}' closedby='any'>
        <fieldset class='dialog-toggle'>
          <div class='dialog-toggle-border'>
            <div class='active'></div>
            <label for='sys'>System</label>
            <input class='theme-options' type='radio' name='themes' id='sys' checked />
            <div class='theme'>
              <div class='active'></div>
              <label for='light'>
                <span>Light</span>
              </label>
              <input class='theme-options' type='radio' name='themes' id='light' />
              <label for='dark'>
                <span>Dark</span>
              </label>
              <input class='theme-options' type='radio' name='themes' id='dark' />
            </div>
          </div>
        </fieldset>
        <fieldset>
            <legend>Styles</legend>
            <select size='${themeListSize}'>
              ${themeOptions}
            </select>
        </fieldset>
        <fieldset>
            <div class='button-box button-box-action'>
                <button id='cancel' aria-label='Cancel changes' title='Cancel'>Cancel</button>
                <button id='apply' aria-label='Apply changes' title='Apply'>Apply</button>
            </div>
        </fieldset>
    </dialog>
  `;
}

function getBanner(url, themeDialog) {
	let text = `
    <button class='mh-banner' aria-label='Dropdown banner'>Matthew's Official Website</button>
    ${themeDialog}
    <div class='mh-banner-content'>
        <div class='mh-banner-content-center'><strong>Welcome to one of Matthew's official websites!</strong><br/></div>
        <div class='mh-banner-content-col1'>&nbsp;</div>
        <div class='mh-banner-content-col2'>
            <strong><u>Matthew's Websites</u></strong><br/>
            <ul>
                <li><a href='https://matthewhanna.com'>Business Website</a></li>
                <li><a href='https://matthewhanna.net'>Resume Website</a></li>
                <li><a href='https://blog.matthewhanna.net'>Coding Blog</a></li>
                <li><a href='https://matthewhanna.me'>Personal Blog</a></li>
            </ul>
        </div>
        <div class='mh-banner-content-col3'>&nbsp;</div>
        <div class='mh-banner-content-col4'>
            <strong><u>Managed Websites</u></strong><br/>
            <ul>
                <li><a href='https://jhausman.ninja'>Jessica Hausman</a></li>
                <li><a href='https://msgdrinking.ninja'>Drinking Giraffe Blog</a></li>
            </ul>
        </div>
        <div class='mh-banner-content-col5'>&nbsp;</div>
        <div class='mh-banner-content-center'>Feel free to explore and learn more about Matthew's work and interests!</div>
        <div class='mh-banner-content-center'><small>Please note, these websites are hobbies and not constantly maintained due to preferences for working.</small></div>
        <div class='mh-banner-content-center'><hr/></div>
    </div>
`;

	let index = text.indexOf(url.hostname);
	if (index > 0) {
		index = text.indexOf('</a></li>', index);
		text = text.slice(0, index + 4) + '&check;' + text.slice(index + 4);
	}

	return text;
}

function getComputedColor(
	el = document.body,
	property = 'color',
	defaultValue = 'white'
) {
	return new Promise((resolve, reject) => {
		try {
			const color = getComputedStyle(el).getPropertyValue(property);
			if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)')
				reject(defaultValue);
			resolve(color);
		} catch {
			reject(defaultValue);
		}
	});
}

function getHoverCSSValue(element, property, fallback = '') {
	const search = `${element}:hover`;
	for (let sheet of document.styleSheets) {
		try {
			const rule = sheet.cssRules.find(
				(r) => r.selectorText.includes(search) && r.style[property]
			);
			if (rule) return rule.style[property];
		} catch {
			// Ignore CORS-restricted stylesheets
		}
	}
	return fallback;
}

function isCSSVarDefined(varName, root = document.documentElement) {
	const value = getComputedStyle(root).getPropertyValue(varName).trim();
	return value !== '';
}

function replaceMissingCSSVar(varName, value, root = document.documentElement) {
	if (!isCSSVarDefined(varName)) {
		root.style.setProperty(varName, value || '');
	}
}

function setBannerColors(state = {}) {
	state.needsMod = false;

	if (
		!isCSSVarDefined('--banner-hover-color') ||
		!isCSSVarDefined('--banner-link-color') ||
		!isCSSVarDefined('--banner-color') ||
		/*!isCSSVarDefined('--banner-content-color') || */
		!isCSSVarDefined('--banner-background-color')
	) {
		const src =
			document.querySelector('.site-nav') ||
			document.querySelector('.navbar') ||
			document.querySelector('.resume-contact') ||
			document.querySelector('nav') ||
			document.querySelector('body');
		if (!src) {
			console.error('no source');
			return false;
		}

		getComputedColor(src, 'background-color')
			.then((c) => replaceMissingCSSVar('--banner-background-color', c))
			.catch((value) => {
				console.log('--banner-background-color catch');
				replaceMissingCSSVar(
					'--banner-background-color',
					`var(--background-color, var(--background, ${value}))`
				);
			});

		getComputedColor(src)
			.then((c) => replaceMissingCSSVar('--banner-color', c))
			.catch((value) => replaceMissingCSSVar('--banner-color', value));

		const anchor = src.querySelector('a');
		let aColor;
		getComputedColor(anchor)
			.then((c) => {
				aColor = c;
				replaceMissingCSSVar('--banner-link-color', c);
			})
			.catch((value) => {
				aColor = value;
				replaceMissingCSSVar('--banner-link-color', value);
			})
			.finally(() => {
				// Add in the hover color from the anchor
				const color = getHoverCSSValue('a', 'color', aColor);
				replaceMissingCSSVar('--banner-hover-color', color);
			});

		state.needsMod = true;
	}
}

function addBannerHeader(state) {
	const header = document.createElement('header');
	header.classList.add('matthews-banner');
	header.style.backdropFilter = 'brightness(150%)';

	const url = new URL(window.location.href);
	const div = document.createElement('div');
	div.innerHTML = getBanner(url, getThemeDialog(url, state));
	header.insertBefore(div, header.firstChild);

	document.body.insertBefore(header, document.body.firstChild);

	return header;
}

function bannerTrigger(btn, content, state) {
	return function () {
		btn.classList.toggle('banner-active');
		if (content.style.maxHeight) {
			content.style.maxHeight = null;
			state.banner = false;
		} else {
			content.style.maxHeight = content.scrollHeight + 'px';
			state.banner = true;
		}
	};
}

function setBannerTrigger(header, state) {
	const bannerButton = header.querySelector('.mh-banner');
	const content = header.querySelector('.mh-banner-content');
	content.style.top = bannerButton.offsetParent.offsetHeight + 'px';

	bannerButton.parentElement.addEventListener(
		'click',
		bannerTrigger(bannerButton, content, state)
	);
}

function themeDialogEvents(popup, state) {
	return function (event) {
		event.stopImmediatePropagation();

		switch (event.target.id) {
			case 'cancel': {
				popup.close();
				state.popup = false;
				break;
			}
			case 'apply': {
				const sld = popup.querySelector('input[name="themes"]:checked');
				state.setTheme(sld.id);

				const style = popup.querySelector('select').value;
				state.setStyle(style);

				if (state.needsMod) {
					document.documentElement.style.removeProperty('--banner-hover-color');
					document.documentElement.style.removeProperty('--banner-link-color');
					document.documentElement.style.removeProperty('--banner-color');
					document.documentElement.style.removeProperty(
						'--banner-background-color'
					);

					setTimeout(setBannerColors, 150);
				}

				popup.close();
				state.popup = false;
				break;
			}
			default:
				break;
		}
	};
}

function themeDialogTrigger(popup, state) {
	return function (event) {
		event.stopImmediatePropagation();
		if (state.popup) return;
		if (state.banner) {
			event.target.parentElement.click();
		}

		if (state.theme) {
			const theme = popup.querySelector(`#${state.theme}`);
			theme.checked = true;
		}

		if (state.style) {
			const style = popup.querySelector('select');
			style.value = state.style;
		}

		popup.show();
		state.popup = true;
	};
}

function themeDialogClosed(state) {
	return function () {
		state.popup = false;
	};
}

function setThemeDialogTriggers(header, state) {
	const popup = header.querySelector('.mh-banner-theme-dialog');
	popup.addEventListener('click', themeDialogEvents(popup, state), true);
	popup.addEventListener('close', themeDialogClosed(state));

	const bannerButton = header.querySelector('.mh-banner');
	const themeButton = header.querySelector('.mh-banner-theme');
	const top =
		bannerButton.offsetParent.offsetHeight / 2 - themeButton.offsetHeight / 2;
	themeButton.style.top = top + 'px';

	themeButton.addEventListener('click', themeDialogTrigger(popup, state), true);
}

function getState(styles = [['default', 'Default']]) {
	const array = Array.isArray(styles)
		? styles
		: Array.from(Object.entries(styles));

	const state = {
		themes: array,
		setTheme: function (val) {
			if (val === 'sys') {
				localStorage.removeItem('theme');
			} else {
				localStorage.setItem('theme', val);
			}
			this.theme = val;
			document.documentElement.dataset['theme'] = val;
		},
		setStyle: function (val) {
			this.themes.forEach((f) =>
				document.documentElement.classList.remove(f[0])
			);
			if (val === 'default') {
				localStorage.removeItem('style');
			} else {
				localStorage.setItem('style', val);
			}
			this.style = val;
			document.documentElement.classList.add(val);
		},
	};

	const cachedTheme = localStorage.getItem('theme');
	if (cachedTheme) {
		document.documentElement.dataset['theme'] = cachedTheme;
		state.theme = cachedTheme;
	} else {
		const theme = document.documentElement.dataset['theme'];
		if (theme) {
			state.theme = theme;
		}
	}

	const cachedStyle = localStorage.getItem('style');
	if (cachedStyle) {
		state.themes.forEach((f) =>
			document.documentElement.classList.remove(f[0])
		);
		document.documentElement.classList.add(cachedStyle);
		state.style = cachedStyle;
	}

	return state;
}

function loadBanner(styles, test = false) {
	const state = getState(styles);
	if (test) state.test = true;

	const header = addBannerHeader(state);

	setBannerTrigger(header, state);

	setBannerColors(state);

	setThemeDialogTriggers(header, state);
}

loadBanner({ default: 'Default', bandw: 'Black and White' }, true);
